export enum ConvertMode {
  line = 'line',
  gap = 'gap',
  delete = 'delete'
}
